import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AccordionMui from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import React, { useState } from "react";
import PlusCircleIcon from "./PlusCircleIcon.svg";
import MinusCircleIcon from "./MinusCircleIcon.svg";
import styles from "./styles.module.scss";
const Accordion = ({ data, defaultExpandedIndex, singleExpand, onChange }) => {
    const [expanded, setExpanded] = useState(defaultExpandedIndex ?? (singleExpand ? null : []));
    const handleChange = (index) => {
        if (singleExpand) {
            setExpanded(expanded === index ? null : index);
        }
        else {
            const newExpanded = Array.isArray(expanded) ? [...expanded] : [];
            const idx = newExpanded.indexOf(index);
            if (idx === -1) {
                newExpanded.push(index);
            }
            else {
                newExpanded.splice(idx, 1);
            }
            setExpanded(newExpanded);
        }
        if (onChange) {
            onChange(index);
        }
    };
    const isExpanded = (index) => {
        if (Array.isArray(expanded)) {
            return expanded.includes(index);
        }
        return expanded === index;
    };
    return (_jsx(_Fragment, { children: data.map((item, index) => (_jsxs(AccordionMui, { expanded: isExpanded(index), onChange: () => handleChange(index), className: styles.accordionItem, children: [_jsx(AccordionSummary, { expandIcon: isExpanded(index) ? _jsx("img", { src: MinusCircleIcon }) : _jsx("img", { src: PlusCircleIcon }), "aria-controls": `panel${index}-content`, id: `panel${index}-header`, className: styles.accordionSummary, children: item.title }), _jsx(AccordionDetails, { className: styles.accordionDetails, children: typeof item.content === "string" ? _jsx("p", { children: item.content }) : item.content })] }, index))) }));
};
export default Accordion;
